"use client";

import React from "react";
import { Heading, HeadingLevel } from "@ariakit/react";

import type { ResourceComponent } from "../Resource/types";
import type { PremiumInformationBox as PremiumInformationBoxType } from "../../../../types/content";

import styles from "./PremiumInformationBox.module.scss";
import { Button } from "../../../Button/Button";
import { PulseTrackPremiumInformationBoxImpression } from "./PulseTrackPremiumInformationBoxImpression";
import { trackPremiumInformationBoxClick } from "../../../../pulse/event/trackPremiumInformationBoxClick";
import { getHref } from "../SalesPosterContainer/helper";

const PremiumInformationBox: ResourceComponent<PremiumInformationBoxType> = ({
  resource,
  article,
}) => {
  const isOmniEconomy = process.env.NEXT_PUBLIC_UI_THEME === "ekonomi";
  const href = getHref(isOmniEconomy, article);
  return (
    <PulseTrackPremiumInformationBoxImpression isOmniEconomy={isOmniEconomy}>
      <div className={styles.premiumInformationBoxContainer}>
        <div className={styles.premiumInformationInnerContainer}>
          <HeadingLevel>
            <Heading className={styles.premiumInformationBoxTitle}>
              {resource.title}
            </Heading>
            <div className={styles.premiumInformationBoxText}>
              <p>{resource.text}</p>
            </div>
            <div className={styles.cta}>
              <Button
                isPremium={true}
                text="Upptäck Omni Mer"
                href={`https://om.omni.se/omni-mer?utm_source=premium_information_box&utm_channel=omni_web&utm_campaign=product_integrated&utm_content=${article?.article_id}&utm_term=acquisition`}
                type="link"
                onClick={() => trackPremiumInformationBoxClick(href)}
              />
            </div>
          </HeadingLevel>
        </div>
      </div>
    </PulseTrackPremiumInformationBoxImpression>
  );
};

export { PremiumInformationBox };
